import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-common-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CommonPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  get headerTitle(): string {
    return this.data?.title || this.formatTemplateName(this.getTemplateName()) || 'Popup';
  }

  private getTemplateName(): string {
    if (this.data?.templateName) {
      return this.data.templateName;
    }

    const template = this.data?.template as any;
    const localNames = template?._declarationTContainer?.localNames;

    if (Array.isArray(localNames) && localNames.length) {
      return localNames[0];
    }

    return '';
  }

  private formatTemplateName(value: string): string {
    return value
      .replace(/Tpl$/, '')
      .replace(/Content$/, '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  }
}
